<template>

  <div class="common-seach-wrap">
    <el-tabs v-model="bannerName">
      <el-tab-pane label="轮播图" name="first"></el-tab-pane>
    </el-tabs>

    
    <Banner v-if="bannerName == 'first'"></Banner>
  </div>
</template>
<script>
import Banner from './banner/index';
export default {
  components: {
    Banner
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      bannerName: 'first'
    };
  },
  methods: {}
};
</script>

<style>
.operation-wrap {
  height: 124px;
  border-radius: 8px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 30px 30px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  background: #909399;
  background-size: 100% 100%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/banner/index.vue